export default __webpack_public_path__ + "static/media/press-page-header-mobile.e904ae21.png";